import axios from 'axios';
import store from '../../store/index';

export default {
	editTenant(tenant) {
		return axios.patch(`api/tenants/${tenant.id}`, tenant, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	deleteTenant(tenant) {
		return axios.delete(`api/tenants/${tenant.id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	addTenant(tenant) {
		return axios.post('api/tenants', tenant, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
